const brcClientConstants = {
  PAYPAL_URL: 'https://www.paypal.com/',
  REQUIRE_FIELD_MSG: 'This field is required',
  ENTERPRISE_SOLUTIONS_MERCATOR_STUDY: 'enterprise-solutions-mercator-study',
  ENTERPRISE_SOLUTIONS_NAVIGATING_NEW_ERA_PAYMENTS: 'enterprise-solutions-navigating-new-era-payments',
  GUIDE_TO_EFFECTIVE_ONLINE_PAYMENTS: 'guide-to-effective-online-payments',
  ENTERPRISE_SOLUTIONS_NEW_PAYMENTS_PROCESSOR: 'enterprise-solutions-new-payments-processor',
  ENTERPRISE_UCC_JUNE_2021: 'enterprise-ucc-june-2021',
  FIELDS_ATTRIBUTES: {
    ARIA_INVALID: 'aria-invalid',
  },
  FIELDS_CLASSES: {
    ERROR_MSG: 'error-message',
    VX_HAS_ERROR: 'vx_has-error',
  }
};

module.exports = brcClientConstants;
